import { useEffect } from 'react';

import { upsertMeta } from './SeoMetaTags';

/**
 * @description
 * 페이지를 검색엔진 색인에서 제외(noindex)하는 컴포넌트입니다.
 * SPA 특성상 404/500 도 HTTP 200 으로 응답(soft-404)하므로,
 * 에러 페이지가 구글에 색인되지 않도록 렌더링 중에만 robots meta 를 추가합니다.
 * (react-helmet 은 React 18 동시성 렌더링 레이스로 meta 가 유실될 수 있어
 * SeoMetaTags 와 동일한 upsertMeta 로 직접 갱신 — robots 태그 관리 주체 단일화)
 */
export const NoIndexMeta = () => {
  useEffect(() => {
    upsertMeta('name', 'robots', 'noindex');
    return () => {
      upsertMeta('name', 'robots', '');
    };
  }, []);

  return null;
};
